import '../styles/style.css'
import HeroCanvas from '../JS/main'

import { useState, useEffect } from 'react';

import TypingEffect from './TypingEffect';

import LoadingAnimation from './LoadingAnimation';

import {useTranslation} from "react-i18next"
// import ProfilePhoto from '../assets/images/Profile-photo.PNG'
export default function SectionOne() {

    const { t } = useTranslation();

    const [visitors, setVisitors] = useState(null);

    useEffect(() => {
        fetch("https://mohamedeltohamy.com/api/visitor.php", {
            method: "GET",
            credentials: "include",
            headers: {
                "X-API-KEY": "MohamedEltohamy_2026_Portfolio"
            }
        })
            .then(res => res.json())
            .then(data => {
                setVisitors(data.count);
            })
            .catch(console.error);
    }, []);

    return (
        <section id="home" className="section sec-1">
            
            <div className="container container-1">
                <HeroCanvas />
                {/* data-aos-delay="2100" */}
                <div data-aos="fade-right"  className="div-photo">
                    <img
                        src="/Profile-photo.PNG"
                        className='My-photo'
                        alt='Mohamed Eltohamy'
                        title="This is my photo"
                    />
                    <div className='text-on-photo text-on-photo1'>
                        <span className="available-dot"></span>
                        <TypingEffect
                            texts={[
                                t("text-photo.text"),
                                t("text-photo.text2"),
                            ]}
                        />
                    </div>
                    <div className='text-on-photo text-on-photo2'>{t("text-photo.name")}</div>
                </div>
                {/* data-aos-delay="2100" */}
                <h1 data-aos="zoom-in" >
                    <span>{t("sec-1.span1")}</span>
                    <span>{t("sec-1.span2")}</span>
                </h1>
            </div>


            <div className='visitors'>
                {t("visitors.text")} :&nbsp;

                {visitors === null ? (
                    <LoadingAnimation/>
                ) : (
                    <span>{visitors}</span>
                )}
            </div>

        </section>
    );
};